'use client';

import { Box, Typography, Chip } from '@mui/material';

import { colorVariables } from '@/constants';
import { Vendor } from '@/lib/types/interfaces/Vendor';

const CategoryLocations = ({ service }: { service: Vendor }) => {
  const [currentCategory] = service.categories;

  const renderCategoryChip = service.categories?.map((item) => (
    <Chip
      label={item.name}
      key={item.id}
      component='li'
    />
  ));
  const renderSubcategoryChips = service.subcategories?.map((item) => (
    <Chip
      label={item.name}
      key={item.id}
      component='li'
    />
  ));

  const renderLocationServedChips = service.locations?.map((item) => (
    <Chip
      label={`${item.name}, ${item.state}`}
      key={item.id}
      component='li'
    />
  ));

  return (
    <>
      {currentCategory && (
        <Box display={{ xs: 'none', lg: 'block' }}>
          <Typography
            variant='h6'
            component='h5'
            fontWeight={600}
            color={colorVariables.textDescription}
          >
            Category
          </Typography>
          <Box
            display='flex'
            flexWrap='wrap'
            gap={1}
            marginTop={1}
            component='ul'
          >
            {renderCategoryChip}
            {renderSubcategoryChips}
          </Box>
        </Box>
      )}

      <Box marginTop={currentCategory ? 3 : 0}>
        <Typography
          variant='h6'
          fontWeight={600}
          color={colorVariables.textDescription}
        >
          Locations Served
        </Typography>
        <Box
          display='flex'
          flexWrap='wrap'
          gap={1}
          marginTop={1}
          component='ul'
        >
          {renderLocationServedChips}
        </Box>
      </Box>
    </>
  );
};

export default CategoryLocations;
